import * as React from 'react'

import classNames from 'classnames/bind'

import styles from './index.module.css'

const cx = classNames.bind(styles)
interface Props {
  type?: 'primary'
}

export default function TableBody({ children, type }: React.PropsWithChildren<Props>) {
  return <tbody className={cx('tbody', type)}>{children}</tbody>
}
